// src/services/PaymentService.js
import axios from "axios";

const PAYMENTS_API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/payments`;
const SALES_API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sales`;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
});

// list all payments (optional global list)
export const listPayments = () =>
  axios.get(PAYMENTS_API_BASE_URL, { headers: authHeaders() });

// create a payment (one-off/manual)
export const createPayment = (payment) =>
  axios.post(PAYMENTS_API_BASE_URL, payment, { headers: authHeaders() });

// log an installment payment for a sale
export const logInstallmentPayment = (salesId, payment) =>
  axios.post(`${PAYMENTS_API_BASE_URL}/sales/${salesId}/installment`, payment, {
    headers: authHeaders(),
  });

// get a payment by id
export const getPaymentById = (paymentId) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/${paymentId}`, {
    headers: authHeaders(),
  });

// get all payments for a sale (ascending by installmentNo)
export const getPaymentsBySalesId = (salesId) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/sales/${salesId}`, {
    headers: authHeaders(),
  });

// get payments for a sale ordered by paidAt desc
export const getPaymentsBySalesIdDesc = (salesId) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/sales/${salesId}/desc`, {
    headers: authHeaders(),
  });

// get latest payment (highest installmentNo) for a sale
export const getLatestPaymentForSale = (salesId) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/sales/${salesId}/latest`, {
    headers: authHeaders(),
  });

// get payments for a sale filtered by status
export const getPaymentsBySalesIdAndStatus = (salesId, status) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/sales/${salesId}/status/${status}`, {
    headers: authHeaders(),
  });

// update a payment record
export const updatePayment = (paymentId, payment) =>
  axios.put(`${PAYMENTS_API_BASE_URL}/${paymentId}`, payment, {
    headers: authHeaders(),
  });

// delete a payment record
export const deletePayment = (paymentId) =>
  axios.delete(`${PAYMENTS_API_BASE_URL}/${paymentId}`, {
    headers: authHeaders(),
  });

// calculate remaining balance for a sale
export const getRemainingBalanceForSale = (salesId) =>
  axios.get(`${PAYMENTS_API_BASE_URL}/sales/${salesId}/remaining-balance`, {
    headers: authHeaders(),
  });

// ✅ new: get next due date for a sale directly from SalesController
export const getNextPaymentDueForSale = (salesId) =>
  axios.get(`${SALES_API_BASE_URL}/${salesId}/next-due`, {
    headers: authHeaders(),
  });
